

import React, { memo } from 'react';
import '../styles/_heatmap-container.scss';





function HeatmapContainer({ children }) {
  return (
    <div className="heatmap-container">
      {children}
    </div>);

}

export default memo(HeatmapContainer);